import { useEffect, useState } from 'react';
import {
  fetchReportCommentsApi,
  StateReport,
} from '../../../api/posts/report-comment.api';

export const useReportCommentManagementHook = ({
  isRefetch,
  status,
}: {
  isRefetch?: boolean;
  status: any;
}) => {
  const [posts, setPosts] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    getReportComments();
  }, [isRefetch, status]);
  const getReportComments = async () => {
    try {
      setLoading(true);
      const { data } = await fetchReportCommentsApi(
        status as unknown as StateReport
      );
      setPosts(data);
    } catch {
      //
    } finally {
      setLoading(false);
    }
  };
  return {
    data: posts,
    loading,
  };
};
